import Navigation from './Navigation'
import Footer from './Footer'

export default function AdminLayout({children, showAdminNavigation = false}) {
    return (
        <div className="root-container">
            {showAdminNavigation && <Navigation/>}
            <main className='main-container adminlayout'>
                <div className='main-sub-container'>
                    {children}
                </div>
                {showAdminNavigation && <Footer/>}
            </main>
        </div>
    )
}
